import {
  ProjectEmptyView,
  ProjectErrorView,
  ProjectHeader,
} from "@/features/project";
import { WorkspaceCard } from "@/features/workspace";
import { useDatabaseStore } from "@/stores/database";
import { Flex } from "@mantine/core";
import { useMemo } from "react";
import { useParams } from "react-router";

export function ProjectPage() {
  const { projectId } = useParams();
  const projects = useDatabaseStore((state) => state.projects);

  const project = useMemo(() => {
    if (!projectId) return null;
    return projects.find((p) => p.id === projectId);
  }, [projectId, projects]);

  // All hooks must be called before any conditional returns
  const noDataflows = project?.dataflows
    ? project.dataflows.length === 0
    : true;

  if (!projectId || !project) {
    return <ProjectErrorView />;
  }

  return (
    <Flex h="100%" direction="column" gap="lg">
      <ProjectHeader project={project} />
      {noDataflows ? (
        <ProjectEmptyView projectId={projectId} />
      ) : (
        <Flex wrap="wrap" gap="md">
          {project.dataflows.map((dataflow) => (
            <WorkspaceCard key={dataflow.dataflow_id} dataflow={dataflow} />
          ))}
        </Flex>
      )}
    </Flex>
  );
}
